// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service from "../../../../proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment from "../../../../proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_info from "../../../../proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service from "../../../../proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_service.js";
import * as Curry from "melange.js/curry.js";

const Employee = {};

const EmploymentType = {};

const EmploymentStatus = {};

const make = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment.Buhta.Payroll.Hrm.V1alpha1.Employment.make;

const Employment = {
  make: make
};

const EmploymentEvent = {};

const make$1 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_info.Buhta.Payroll.Hrm.V1alpha1.EmploymentInfo.make;

const EmploymentInfo = {
  make: make$1
};

function toCreateRequest(form) {
  return Curry._2(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.CreateEmployeeRequest.make, form, undefined);
}

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.UpdateEmployeeRequest.make, id, form, undefined);
}

const EmployeeForm = {
  toCreateRequest: toCreateRequest,
  toUpdateRequest: toUpdateRequest
};

function toCreateRequest$1(employee, form) {
  return Curry._3(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.CreateEmploymentEventRequest.make, employee, form, undefined);
}

function toUpdateRequest$1(employee, id, form) {
  return Curry._4(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.UpdateEmploymentEventRequest.make, employee, id, form, undefined);
}

const EmploymentEventForm = {
  toCreateRequest: toCreateRequest$1,
  toUpdateRequest: toUpdateRequest$1
};

const apiEndpointPrefix = "/payroll";

function view(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._3(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.GetEmployeeRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.employee);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.getEmployee, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.GetEmployee.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.ListEmployeesRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.employees;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.listEmployees, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.ListEmployees.name, undefined, undefined));
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.employee);
              }), Buhta_core__Grpc.makeRpc(toCreateRequest(form), Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.createEmployee, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.CreateEmployee.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.employee);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest(id, form), Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.updateEmployee, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee_service.Buhta.Payroll.Hrm.V1alpha1.EmployeeService.UpdateEmployee.name, undefined, undefined));
}

const EmployeeService = {
  view: view,
  grid: grid,
  create: create,
  update: update
};

function view$1(tenant, expandOpt, employee, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._4(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.GetEmploymentEventRequest.make, employee, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.event);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.getEmploymentEvent, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.GetEmploymentEvent.name, undefined, undefined));
}

function grid$1(tenant, employee, params, param) {
  const request = Curry._3(Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.ListEmploymentEventsRequest.make, employee, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.events;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.listEmploymentEvents, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.ListEmploymentEvents.name, undefined, undefined));
}

function create$1(tenant, employee, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.event);
              }), Buhta_core__Grpc.makeRpc(toCreateRequest$1(employee, form), Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.createEmploymentEvent, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.CreateEmploymentEvent.name, undefined, undefined));
}

function update$1(tenant, employee, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.event);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest$1(employee, id, form), Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.updateEmploymentEvent, undefined, tenant, undefined, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_service.Buhta.Payroll.Hrm.V1alpha1.EmploymentService.UpdateEmploymentEvent.name, undefined, undefined));
}

const EmploymentService = {
  view: view$1,
  grid: grid$1,
  create: create$1,
  update: update$1
};

export {
  Employee ,
  EmploymentType ,
  EmploymentStatus ,
  Employment ,
  EmploymentEvent ,
  EmploymentInfo ,
  EmployeeForm ,
  EmploymentEventForm ,
  EmployeeService ,
  EmploymentService ,
}
/* Buhta_core__Grpc Not a pure module */
